export enum OrderFilterKeys {
  created = "created",
  deliveryDate = "deliveryDate",
  customer = "customer",
  status = "status",
  paymentStatus = "paymentStatus",
  clickAndCollect = "clickAndCollect",
  preorder = "preorder",
  channel = "channel",
  giftCard = "giftCard",
  metadata = "metadata",
}

export enum OrderFilterGiftCard {
  bought = "bought",
  paid = "paid",
}
